import { axiosInstance } from "@customer-experience/freem-lead-client";

const isStaging = process.env.REACT_APP_DEPLOYMENT_ENV !== "production" ? true : false;

const LEAD_SERVICE_STAGING_DOMAIN = "staging.chevalier.group";
const LEAD_SERVICE_PRODUCTION_DOMAIN = "chevalier.group";

const domain = isStaging ? LEAD_SERVICE_STAGING_DOMAIN : LEAD_SERVICE_PRODUCTION_DOMAIN;

axiosInstance.defaults.baseURL = `https://${domain}/freem`;

export * as leadApi from "./lead";
export * as trackingApi from "./tracking";
